import { useFeatureFlagEnabled } from "@posthog/react";

export function useTeenWallEnabled(): boolean {
  return useFeatureFlagEnabled("teen-wall-enabled") || import.meta.env.DEV;
}
